import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { RoutingService } from '../routing.service';
import { TokenService } from '../token.service';
import { CommonConfig } from 'src/app/shared/common-config/common-config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppGuard {
  init: boolean = false;

  constructor(
    private tokenService: TokenService,
    private authService: MareAuthService,
    private router: Router,
    private routingService: RoutingService,
    private configService: CommonConfig
    ) {

  }

  canActivate(): Promise<boolean | UrlTree> | boolean | UrlTree {
    if(this.init) {
      return this._canActivate();
    } 
    if (this.tokenService && this.tokenService.isInit$) {
      return new Promise<boolean | UrlTree>((resolve, reject) => {
        this.tokenService.isInit$.subscribe((isInit) => {
          if (isInit) {
            this.init = true;
            resolve(this._canActivate())
          }
        })
      });
    } else {
      this.init = true;
      return this._canActivate();
    }
  }
  _canActivate() : boolean | UrlTree {
    if (!this.authService.isLogged()) {
      const requestedUrl = window.location.pathname;
      let params: any[] = [];
      if(window.location.search && window.location.search.startsWith('?')) {
        window.location.search.split('?')[1].split('&').forEach((param) => {
          const [key, value] = param.split('=');
          params.push({key, value});
        })
      };
      this.routingService.setRequestedUrl(requestedUrl, params);
      
      const urlTree = this.router.parseUrl(this.configService.getFromConfig('unauthorizedRedirect', environment.routingBasePath + '/login'));
      return urlTree;
      // return this.router.parseUrl('/account/marketplace');
      // return UrlTree
    }

    // console.log('can activate_______________________')
    return this.authService.isLogged();
  }

}
